import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Facebook, Instagram, Linkedin } from "lucide-react";
import logo from "../assets/images/logo.webp";
import { FaWhatsapp } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot
} from "@fortawesome/free-solid-svg-icons";

const Footer = () => {

  const location = useLocation();

  // Home page par Footer hide
  if (location.pathname === "/") {
    return null;
  }

  return (
    <footer>
      <div>

        <div className="footer-navbar">

          <div className="container footer-main-section">
            <div className="row">

              <div className="col-md-12 col-lg-5">

                <a className="footer-logo" href="/">
                  <img src={logo} alt="Logo" />
                </a>

                <p className="footer-pra">
                  TheOmSaga is a spiritual platform inspired by real-life
                  stories of faith, devotion, and divine presence.
                  Born from a belief in the supreme power, it reflects
                  experiences that bring peace, courage, and hope.
                  It gives voice to untold stories that remind us we are
                  always seen, heard, and protected.
                  More than storytelling, TheOmSaga is a journey that
                  strengthens faith and spreads positivity across generations.
                </p>

                <div className="d-flex footer-social-section">

                  <Link
                    to="https://www.facebook.com/share/1B44vEtGc7/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Facebook size={28} className="footer-icon" />
                  </Link>

                  <Link
                    to="https://www.linkedin.com/company/theomsaga/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Linkedin size={28} className="footer-icon" />
                  </Link>

                  <Link
                    to="https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw=="
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Instagram size={28} className="footer-icon" />
                  </Link>

                </div>

              </div>

              <div className="col-md-6 col-lg-3">

                <div className="footer-link-section">

                  <p className="footer-link-head">
                    Useful Links
                  </p>

                  <ul className="footer-link list-unstyled text-start">

                    <li>
                      <Link
                        to="/"
                        className="text-light text-decoration-none"
                      >
                        Home
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/aboutus"
                        className="text-light text-decoration-none"
                      >
                        About
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/stories"
                        className="text-light text-decoration-none"
                      >
                        Soul Tales
                      </Link>
                    </li>
 <li>
                      <Link
                         to="/gallery"
                        className="text-light text-decoration-none"
                      >
                        Gallery
                      </Link>
                    </li>
                     <li>
                      <Link
                         to="/contribute"
                        className="text-light text-decoration-none"
                      >
                        Contribute
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/createstory"
                        className="text-light text-decoration-none"
                      >
                        Story Creator
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/termsandconditions"
                        className="text-light text-decoration-none"
                      >
                        Terms & Conditions
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/contactus"
                        className="text-light text-decoration-none"
                      >
                        Contact
                      </Link>
                    </li>

                  </ul>

                </div>

              </div>

              <div className="col-md-6 col-lg-3">

                <div className="footer-contact-section">

                  <p className="footer-link-head">
                    Contact Us
                  </p>

                  <Link to="mailto:info@theomsaga.com" target="_blank">
                    <div className="d-flex mt-0">

                      <span className="footer-icons">
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          className="footer-svg-icon"
                        />
                      </span>

                      <div>
                        <p className="footer-icon-head">
                          info@theomsaga.com
                        </p>
                      </div>

                    </div>
                  </Link>

                  <Link to="tel:+918197571882" target="_blank">
                    <div className="d-flex">

                      <span className="footer-icons">
                        <FaWhatsapp
                          className="footer-svg-icon whatsp-footer-icon"
                        />
                      </span>

                      <div>
                        <p className="footer-icon-head">
                          +91 8197571882
                        </p>
                      </div>

                    </div>
                  </Link>

                  <Link to="" target="_blank">
                    <div className="d-flex">

                      <span className="footer-icons location-footer-icon">
                        <FontAwesomeIcon
                          icon={faLocationDot}
                          className="footer-svg-icon"
                        />
                      </span>

                      <div>
                        <p className="footer-icon-head">
                          Bengaluru, Karnataka – 560038, India
                        </p>
                      </div>

                    </div>
                  </Link>

                </div>

              </div>

            </div>
          </div>

          <div className="copyright-section text-center py-3">
            <p className="mb-0">
              Copyright by TheOmSaga. All rights reserved.
            </p>
          </div>

        </div>

      </div>
    </footer>
  );
};

export default Footer;